import { render, staticRenderFns } from "./LmDraggableFormComponentSettings.vue?vue&type=template&id=01a81ea0&"
import script from "./LmDraggableFormComponentSettings.vue?vue&type=script&lang=js&"
export * from "./LmDraggableFormComponentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports